






import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class DialogFooter extends Vue {
  @Prop({default: false, type: Boolean}) confirm
  @Prop({default: '확인', type: String}) textClose
  @Prop({default: '', type: String}) textAgree

  get isAgree() {
    return this.textAgree.trim().length > 0
  }
}
